import { useParams } from 'react-router-dom';
import { config } from "../../data/config";
import { useEffect } from 'react';
import { getCookies } from "cookies-next";
import { useCookies } from 'react-cookie';
import axios from "axios";
import { useState } from "react";
import BreadCrump from "../tools/breadcrump"

import * as React from 'react';
import TissEditor from '../Editor/TissEditor';
import ImageUploader from '../tools/uploaderImage';
import { useTranslation } from 'react-i18next';
import Swal from 'sweetalert2';
import { Modal, Form, Input, Button, CheckboxGroup, Checkbox } from 'rsuite';
import HeaderOfPage from '../tools/headerOfPage';
import PriceEditor from './PriceEditor';
import { motion } from "framer-motion";
import changeUrl from "../../hoc/changeur";

type LanguageCode = 'ku' | 'fa' | 'en' | 'ar' | 'tr';

interface MultilingualField {
    ku: string;
    fa: string;
    en: string;
    ar: string;
    tr: string;
}

export default function ProductGroupEdit() {
    const { t } = useTranslation();

    let cookie = getCookies();

    let { Id } = useParams();
    const [cookies, setCookie] = useCookies(['token', 'rule']);
    const [key, setKey] = useState<any>(1);
    const [error, setError] = useState<any>(null);
    const [listpost, setListPost] = useState<any[]>([]);
    const [listprices, setListpirces] = useState<any[]>([]);

    const loaditem = async (id: any) => {
        try {
            var path = `${config.url}/v1/dashboard/price/list/${id}`;

            let res = await axios({
                method: 'get',
                url: path,
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });
            setListpirces(res.data.message);
        } catch (error) {

        }
    }

    const [data, setData] = React.useState<any>(null);
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [success, setSuccess] = useState(false);
    const [activeLang, setActiveLang] = useState<LanguageCode>('en');

    const languages: Array<{ code: LanguageCode; label: string }> = [
        { code: 'ku' as LanguageCode, label: 'Kurdish' },
        { code: 'fa' as LanguageCode, label: 'فارسی' },
        { code: 'en' as LanguageCode, label: 'English' },
        { code: 'ar' as LanguageCode, label: 'العربية' },
        { code: 'tr' as LanguageCode, label: 'Türkçe' }
    ];

    // Helper function to safely access multilingual fields
    const getMultilingualValue = (field: any, lang: LanguageCode): string => {
        if (!field) return '';
        if (typeof field === 'string') return field; // Legacy support
        if (typeof field === 'object' && field !== null && !Array.isArray(field)) {
            return field[lang] || field.en || field.fa || field.ku || field.ar || field.tr || '';
        }
        return '';
    };

    // Initialize multilingual data from legacy string format
    const initializeMultilingualData = (field: any): MultilingualField => {
        if (!field) return { ku: '', fa: '', en: '', ar: '', tr: '' };
        if (typeof field === 'string') {
            return { ku: '', fa: '', en: field, ar: '', tr: '' };
        }
        if (typeof field === 'object' && field !== null && !Array.isArray(field)) {
            return {
                ku: field.ku || '',
                fa: field.fa || '',
                en: field.en || '',
                ar: field.ar || '',
                tr: field.tr || ''
            };
        }
        return { ku: '', fa: '', en: '', ar: '', tr: '' };
    };
    
    const save = async () => {
        const currentName = data?.name ? getMultilingualValue(data.name, activeLang) : '';
        const currentUrl = data?.url ? getMultilingualValue(data.url, activeLang) : '';
        
        if (!currentName || !currentUrl) {
            Swal.fire({
                icon: 'warning',
                title: t('Validation Error'),
                text: t('Please fill in all required fields'),
                timer: 2000,
                showConfirmButton: false
            });
            return;
        }

        setSaving(true);
        setSuccess(false);
        setError(null);
        
        try {
            var path = `${config.url}/v1/dashboard/productprice/${Id}`;

            let res = await axios({
                method: 'put',
                data: data,
                url: path,
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });
            
            Swal.fire({
                icon: 'success',
                title: t('Updated'),
                text: t('Price group updated successfully'),
                timer: 2000,
                showConfirmButton: false
            });
            
            setSuccess(true);
            setTimeout(() => setSuccess(false), 3000);
        } catch (error: any) {
            setError(error.response?.data?.message || t('Error saving'));
            Swal.fire({
                icon: 'error',
                title: t('Error'),
                text: error.response?.data?.message || t('Error saving')
            });
        } finally {
            setSaving(false);
        }
    }
 

    const load = async () => {
        setLoading(true);
        try {
            var path = `${config.url}/v1/dashboard/productprice/${Id}`;

            let res = await axios({
                method: 'get',
                url: path,
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });
            const loadedData = res.data.message;
            // Convert legacy string fields to multilingual objects if needed
            if (loadedData) {
                if (typeof loadedData.name === 'string') {
                    loadedData.name = initializeMultilingualData(loadedData.name);
                }
                if (typeof loadedData.url === 'string') {
                    loadedData.url = initializeMultilingualData(loadedData.url);
                }
                if (typeof loadedData.keywords === 'string') {
                    loadedData.keywords = initializeMultilingualData(loadedData.keywords);
                }
                if (typeof loadedData.description === 'string') {
                    loadedData.description = initializeMultilingualData(loadedData.description);
                }
            }
            setData(loadedData)
        } catch (error: any) {
            setError(error.response?.data?.message || t('Error loading data'));
            Swal.fire({
                icon: 'error',
                title: t('Error'),
                text: error.response?.data?.message || t('Error loading data')
            });
        }
        try {
            var path = `${config.url}/v1/dashboard/postmethods`;

            let res = await axios({
                method: 'get',
                url: path,
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });
            setListPost(res.data.message)
        } catch (error) {
            // Silent fail for postmethods
        } finally {
            setLoading(false);
        }
    }
    const inputstyle = "w-full px-4 py-3 border-2 border-gray-200 rounded-xl text-sm text-gray-900 bg-white focus:outline-none focus:ring-4 focus:ring-blue-100 focus:border-blue-500 transition-all duration-200 placeholder-gray-400 hover:border-gray-300 shadow-sm hover:shadow-md focus:shadow-lg";
    const labelStyle = "flex items-center gap-1 text-sm font-semibold text-gray-700 mb-2.5";
    const breadcrump = [
        {
            name: 'Dashboard',
            url: '/dashboard'
        },
        {
            name: 'Products',
            url: '/dashboard/ProductsGroup'
        },
        {
            name: 'PriceGroup Group List',
            url: '/dashboard/PriceGroup'
        },
        {
            name: 'Edit PriceGroup Group List',
            url: null
        }
    ]
    useEffect(() => {
        load();
        loaditem(Id);
    }, []);
  
 
    if (loading) {
        return (
            <div className="min-h-screen bg-gradient-to-br from-gray-50 via-blue-50 to-indigo-50 p-4 md:p-6 lg:p-8" dir={t("dir")}>
                <div className="max-w-7xl mx-auto">
                    <motion.div
                        initial={{ opacity: 0, y: -20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.3 }}
                        className="mb-6"
                    >
                        <BreadCrump data={breadcrump}></BreadCrump>
                    </motion.div>
                    
                    <div className="bg-white rounded-2xl shadow-xl p-16 border border-gray-100">
                        <div className="flex flex-col items-center justify-center">
                            <div className="relative">
                                <div className="animate-spin rounded-full h-16 w-16 border-4 border-blue-100 border-t-blue-600"></div>
                                <div className="absolute inset-0 flex items-center justify-center">
                                    <svg className="w-8 h-8 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                    </svg>
                                </div>
                            </div>
                            <p className="text-center text-gray-600 mt-6 font-semibold text-lg">{t('Loading...')}</p>
                            <p className="text-center text-gray-400 mt-2 text-sm">{t('Please wait while we fetch your data')}</p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="min-h-screen bg-gradient-to-br from-gray-50 via-blue-50 to-indigo-50 p-4 md:p-6 lg:p-8" dir={t("dir")}>
            <div className="max-w-7xl mx-auto">
                <motion.div
                    initial={{ opacity: 0, y: -20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.3 }}
                    className="mb-6"
                >
                    <BreadCrump data={breadcrump}></BreadCrump>
                </motion.div>
                
                <motion.div
                    initial={{ opacity: 0, y: -20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.3, delay: 0.1 }}
                    className="mb-8"
                >
                    <HeaderOfPage name={t("Edit PriceGroup Group List")}></HeaderOfPage>
                </motion.div>

                {data != null && (
                    <div className='grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-8'>
                        {/* Left Sidebar - Form */}
                        <motion.div
                            initial={{ opacity: 0, x: -20 }}
                            animate={{ opacity: 1, x: 0 }}
                            transition={{ duration: 0.4, delay: 0.2 }}
                            className="lg:col-span-4 xl:col-span-3"
                        >
                            <div className="bg-white rounded-xl shadow-lg overflow-hidden border border-gray-100 sticky top-4">
                                <div className="bg-gradient-to-r from-blue-600 via-indigo-600 to-purple-600 px-6 py-4">
                                    <div className="flex items-center gap-3">
                                        <div className="w-10 h-10 bg-white/20 rounded-lg flex items-center justify-center backdrop-blur-sm shadow-md">
                                            <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                                            </svg>
                                        </div>
                                        <div>
                                            <h4 className="text-white text-lg font-bold">{t('Edit')}</h4>
                                            <p className="text-blue-100 text-xs mt-0.5">{t('Update price group information')}</p>
                                        </div>
                                    </div>
                                </div>

                                <form key={key} className="p-6 space-y-5" dir={t("dir")}>
                                    {success && (
                                        <motion.div
                                            initial={{ opacity: 0, scale: 0.9 }}
                                            animate={{ opacity: 1, scale: 1 }}
                                            className="p-3 bg-green-50 border border-green-200 rounded-lg flex items-center gap-2"
                                        >
                                            <svg className="w-5 h-5 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                                            </svg>
                                            <span className="text-sm text-green-700 font-medium">{t('Price group updated successfully!')}</span>
                                        </motion.div>
                                    )}

                                    {error && (
                                        <motion.div
                                            initial={{ opacity: 0, y: -10 }}
                                            animate={{ opacity: 1, y: 0 }}
                                            className="p-3 bg-red-50 border border-red-200 rounded-lg flex items-start gap-2"
                                        >
                                            <svg className="w-5 h-5 text-red-600 flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                            </svg>
                                            <span className="text-sm text-red-700">{error}</span>
                                        </motion.div>
                                    )}

                                    {/* Language Selector */}
                                    {languages && languages.length > 0 && (
                                        <div className="mb-4 p-4 bg-gradient-to-r from-blue-50 to-indigo-50 rounded-xl border border-blue-200">
                                            <label className="flex items-center gap-2 text-sm font-semibold text-gray-800 mb-3">
                                                <svg className="w-5 h-5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5h12M9 3v2m1.048 9.5A18.022 18.022 0 016.412 9m6.088 9h7M11 21l5-10 5 10M12.751 5C11.783 10.77 8.07 15.61 3 18.129" />
                                                </svg>
                                                {t('Language')} / زبان
                                            </label>
                                            <div className="flex gap-2 flex-wrap">
                                                {languages.map((lang) => (
                                                    <motion.button
                                                        key={lang.code}
                                                        type="button"
                                                        onClick={() => setActiveLang(lang.code)}
                                                        whileHover={{ scale: 1.05 }}
                                                        whileTap={{ scale: 0.95 }}
                                                        className={`px-4 py-2.5 text-sm font-semibold rounded-lg transition-all duration-200 ${
                                                            activeLang === lang.code
                                                                ? 'bg-gradient-to-r from-blue-600 to-indigo-600 text-white shadow-lg ring-2 ring-blue-300'
                                                                : 'bg-white text-gray-700 hover:bg-gray-50 shadow-md border border-gray-200 hover:border-blue-300'
                                                        }`}
                                                    >
                                                        {lang.label}
                                                    </motion.button>
                                                ))}
                                            </div>
                                        </div>
                                    )}

                                    <div>
                                        <label className={labelStyle}>
                                            <svg className="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z" />
                                            </svg>
                                            {t('Name')} ({languages.find(l => l.code === activeLang)?.label}) <span className="text-red-500 font-bold">*</span>
                                        </label>
                                        <div className="relative group">
                                            <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                                                <svg className="w-5 h-5 text-gray-400 group-focus-within:text-blue-500 transition-colors" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z" />
                                                </svg>
                                            </div>
                                            <input
                                                value={getMultilingualValue(data?.name, activeLang)}
                                                type="text"
                                                className={`${inputstyle} pr-10 ${error != null && error['name'] != undefined ? 'border-red-400 bg-red-50 focus:ring-red-200 focus:border-red-500' : ''} ${getMultilingualValue(data?.name, activeLang) && !error ? 'border-green-400 pr-12' : ''}`}
                                                placeholder={t('Enter price group name')}
                                                onChange={(e) => {
                                                    const currentName = data?.name || { ku: '', fa: '', en: '', ar: '', tr: '' };
                                                    const updatedName = typeof currentName === 'string' 
                                                        ? initializeMultilingualData(currentName)
                                                        : { ...currentName };
                                                    updatedName[activeLang] = e.target.value;
                                                    setData({ ...data, name: updatedName });
                                                }}
                                            />
                                            {getMultilingualValue(data?.name, activeLang) && !error && (
                                                <div className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none animate-in fade-in duration-200">
                                                    <svg className="w-5 h-5 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                                                    </svg>
                                                </div>
                                            )}
                                        </div>
                                        {error != null && error['name'] != undefined && (
                                            <motion.p 
                                                initial={{ opacity: 0, y: -5 }}
                                                animate={{ opacity: 1, y: 0 }}
                                                className="mt-2 text-xs text-red-600 flex items-center gap-1.5 bg-red-50 px-3 py-2 rounded-lg border border-red-200"
                                            >
                                                <svg className="w-4 h-4 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                                                    <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                                                </svg>
                                                <span>{error['name']['message']}</span>
                                            </motion.p>
                                        )}
                                    </div>

                                    <div>
                                        <label className={labelStyle}>
                                            <svg className="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1" />
                                            </svg>
                                            {t('Slug')} ({languages.find(l => l.code === activeLang)?.label}) <span className="text-red-500 font-bold">*</span>
                                        </label>
                                        <div className="relative group">
                                            <span className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-500 text-sm font-medium group-focus-within:text-blue-500 transition-colors">/</span>
                                            <input
                                                type="text"
                                                value={getMultilingualValue(data?.url, activeLang)}
                                                className={`${inputstyle} ${error != null && error['url'] != undefined ? 'border-red-400 bg-red-50 focus:ring-red-200 focus:border-red-500' : ''} ${getMultilingualValue(data?.url, activeLang) && !error ? 'border-green-400 pl-8 pr-12' : 'pl-8'} ${!getMultilingualValue(data?.url, activeLang) ? 'pl-8' : ''}`}
                                                placeholder={t('URL slug (auto-generated)')}
                                                onChange={(e) => {
                                                    const currentUrl = data?.url || { ku: '', fa: '', en: '', ar: '', tr: '' };
                                                    const updatedUrl = typeof currentUrl === 'string' 
                                                        ? initializeMultilingualData(currentUrl)
                                                        : { ...currentUrl };
                                                    updatedUrl[activeLang] = e.target.value;
                                                    setData({ ...data, url: updatedUrl });
                                                }}
                                            />
                                            {getMultilingualValue(data?.url, activeLang) && !error && (
                                                <div className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none animate-in fade-in duration-200">
                                                    <svg className="w-5 h-5 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                                                    </svg>
                                                </div>
                                            )}
                                        </div>
                                        {error != null && error['url'] != undefined && (
                                            <motion.p 
                                                initial={{ opacity: 0, y: -5 }}
                                                animate={{ opacity: 1, y: 0 }}
                                                className="mt-2 text-xs text-red-600 flex items-center gap-1.5 bg-red-50 px-3 py-2 rounded-lg border border-red-200"
                                            >
                                                <svg className="w-4 h-4 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                                                    <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                                                </svg>
                                                <span>{error['url']['message']}</span>
                                            </motion.p>
                                        )}
                                    </div>

                                    <div>
                                        <label className={labelStyle}>
                                            <svg className="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z" />
                                            </svg>
                                            {t('Keywords')} ({languages.find(l => l.code === activeLang)?.label})
                                        </label>
                                        <textarea
                                            value={getMultilingualValue(data?.keywords, activeLang)}
                                            rows={3}
                                            className={`${inputstyle} resize-none`}
                                            onChange={(e) => {
                                                const currentKeywords = data?.keywords || { ku: '', fa: '', en: '', ar: '', tr: '' };
                                                const updatedKeywords = typeof currentKeywords === 'string' 
                                                    ? initializeMultilingualData(currentKeywords)
                                                    : { ...currentKeywords };
                                                updatedKeywords[activeLang] = e.target.value;
                                                setData({ ...data, keywords: updatedKeywords });
                                            }}
                                            placeholder={t('Enter keywords (optional)')}
                                        />
                                    </div>

                                    <div>
                                        <label className={labelStyle}>
                                            <svg className="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h7" />
                                            </svg>
                                            {t('Description')} ({languages.find(l => l.code === activeLang)?.label})
                                        </label>
                                        <textarea
                                            value={getMultilingualValue(data?.description, activeLang)}
                                            rows={4}
                                            className={`${inputstyle} resize-none`}
                                            onChange={(e) => {
                                                const currentDescription = data?.description || { ku: '', fa: '', en: '', ar: '', tr: '' };
                                                const updatedDescription = typeof currentDescription === 'string' 
                                                    ? initializeMultilingualData(currentDescription)
                                                    : { ...currentDescription };
                                                updatedDescription[activeLang] = e.target.value;
                                                setData({ ...data, description: updatedDescription });
                                            }}
                                            placeholder={t('Enter description (optional)')}
                                        />
                                    </div>

                                    <motion.button
                                        type="button"
                                        whileHover={{ scale: 1.02 }}
                                        whileTap={{ scale: 0.98 }}
                                        onClick={(e) => { save() }}
                                        disabled={saving || !getMultilingualValue(data?.name, activeLang) || !getMultilingualValue(data?.url, activeLang)}
                                        className="w-full py-3 px-4 inline-flex items-center justify-center gap-2 text-sm font-semibold rounded-lg bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 text-white shadow-md hover:shadow-lg transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:shadow-md"
                                    >
                                        {saving ? (
                                            <>
                                                <div className="animate-spin rounded-full h-4 w-4 border-2 border-white border-t-transparent"></div>
                                                <span>{t('Saving...')}</span>
                                            </>
                                        ) : (
                                            <>
                                                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                                                </svg>
                                                <span>{t('Update Category')}</span>
                                            </>
                                        )}
                                    </motion.button>
                                    {(!getMultilingualValue(data?.name, activeLang) || !getMultilingualValue(data?.url, activeLang)) && (
                                        <p className="text-xs text-gray-500 text-center">
                                            {t('Fill in required fields to enable')}
                                        </p>
                                    )}
                                </form>
                            </div>
                        </motion.div>

                        {/* Right Side - Price Editor */}
                        <motion.div
                            initial={{ opacity: 0, x: 20 }}
                            animate={{ opacity: 1, x: 0 }}
                            transition={{ duration: 0.4, delay: 0.3 }}
                            className="lg:col-span-8 xl:col-span-9"
                        >
                            <div className="bg-white rounded-xl shadow-lg overflow-hidden border border-gray-100">
                                <PriceEditor Id={Id} key={3} />
                            </div>
                        </motion.div>
                    </div>
                )}
            </div>
        </div>
    )
}